import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [``],
})
export class PageAccessComponent implements OnInit {
    public mode: string = 'login';
    public loginData: any = { email: '', password: '' };
    public signupData: any = { email: '', password: '', passwordConfirm: '', name: '', license_number: '', mobile: '' };
    public errorMessage: string = '';
    public loading: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        // 이미 로그인된 경우 대시보드로 이동
        if (this.service.auth.check()) {
            this.service.href('/dashboard');
            return;
        }
        await this.service.render();
    }

    public switchMode(mode: string) {
        this.mode = mode;
        this.errorMessage = '';
        this.service.render();
    }

    public async login() {
        this.errorMessage = '';
        if (!this.loginData.email || !this.loginData.password) {
            this.errorMessage = '이메일과 비밀번호를 입력해주세요.';
            await this.service.render();
            return;
        }
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call('login', {
            email: this.loginData.email,
            password: this.loginData.password
        });

        this.loading = false;

        if (code === 200) {
            this.service.href('/dashboard');
            return;
        }

        this.errorMessage = data?.message || '로그인에 실패했습니다.';
        await this.service.render();
    }

    public async signup() {
        this.errorMessage = '';
        const d = this.signupData;

        if (!d.email || !d.password || !d.name) {
            this.errorMessage = '필수 항목을 모두 입력해주세요.';
            await this.service.render();
            return;
        }
        if (d.password !== d.passwordConfirm) {
            this.errorMessage = '비밀번호가 일치하지 않습니다.';
            await this.service.render();
            return;
        }
        if (d.password.length < 6) {
            this.errorMessage = '비밀번호는 6자 이상이어야 합니다.';
            await this.service.render();
            return;
        }

        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call('signup', {
            email: d.email,
            password: d.password,
            name: d.name,
            license_number: d.license_number,
            mobile: d.mobile
        });

        this.loading = false;

        if (code === 200) {
            await this.service.modal.show({
                title: '회원가입 완료',
                message: '회원가입이 완료되었습니다. 로그인해주세요.',
                status: 'success',
                actionBtn: 'success',
                action: '확인',
                cancel: false
            });
            this.mode = 'login';
            this.loginData.email = d.email;
            await this.service.render();
            return;
        }

        this.errorMessage = data?.message || '회원가입에 실패했습니다.';
        await this.service.render();
    }

    public onKeydown(event: any, action: string) {
        if (event.key === 'Enter') {
            if (action === 'login') this.login();
            else if (action === 'signup') this.signup();
        }
    }
}

export default PageAccessComponent;